export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10021.4eb54689.jpg";